export const LANDING = '/';
export const SIGN_UP = '/signup';
export const SIGN_IN = '/signin';
export const HOME = '/home';
export const ACCOUNT = '/account';
export const PASSWORD_FORGET = '/pw-forget';
export const ADMIN = '/admin';
export const ADMIN_DETAILS = '/admin/:id';
export const USERS = '/admin/users';
export const EDIT_USER = '/admin/users/:id/edit';
export const CREATE_USER = '/admin/users/create_instructor';
export const AVAILABILITY = '/availability';
